import {
  useGetTowProRequestsQuery,
  useIsEditingResourceRequest,
  useSelectedRequestId,
} from '@rsos/reduxDataStore/src/features/resourceRequests';
import { FullWidthContent } from '../../tabs/OverviewTab/OverviewTab.styles';
import { FormContent } from '../ResourceRequestPanel/ResourceRequestPanel.styles';
import TowProForm from './TowProForm';
import TowProStatus from './TowProStatus';

/**
 * Detail view for the towpro panel view. Routes between the tow request
 * form, the status of the selected request, and its edit form.
 */
function TowProView() {
  const selectedRequestId = useSelectedRequestId();
  const isEditing = useIsEditingResourceRequest();
  const { data: requests } = useGetTowProRequestsQuery();

  const selectedRequest =
    requests?.find(request => String(request.id) === selectedRequestId) ?? null;

  let content = null;
  if (!selectedRequestId) {
    content = <TowProForm />;
  } else if (selectedRequest) {
    content = isEditing ? (
      <TowProForm existingRequest={selectedRequest} />
    ) : (
      <TowProStatus request={selectedRequest} />
    );
  }

  return (
    <FormContent data-name="towpro-view">
      <FullWidthContent backgroundColor="background" noBorder>
        {content}
      </FullWidthContent>
    </FormContent>
  );
}

export default TowProView;
